import { useContext, useMemo, type ReactNode } from 'react';

import { ReactRelayContext, RelayEnvironmentProvider } from 'react-relay';

import { initRelayEnvironment } from '../relay-environment';

type WacRelayEnvironmentProviderProps = {
	children: ReactNode;
};

/**
 * Makes sure every WAC page has a Relay environment, so components (for example
 * EntryPoint-based popups) can call `useRelayEnvironment()` without adding their own provider.
 *
 * Entries that already provide an environment (such as `init-relay-streaming`, which seeds it
 * with the SSR snapshot) keep theirs. Otherwise the app's shared `initRelayEnvironment()` is used.
 */
export const WacRelayEnvironmentProvider = ({ children }: WacRelayEnvironmentProviderProps) => {
	const existingEnvironment = useContext(ReactRelayContext)?.environment;
	const environment = useMemo(
		() => existingEnvironment ?? initRelayEnvironment(),
		[existingEnvironment],
	);

	if (existingEnvironment) {
		return <>{children}</>;
	}

	return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>;
};
